import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface StepperItems {
    activeStepper: number;
}
const initialState: StepperItems = {
    activeStepper: 0,
};

const stepperSlice = createSlice({
    name: 'HomePageSteppersSlice',
    initialState,
    reducers: {
        changeActiveStepper: (state, action: PayloadAction<number>) => {
            state.activeStepper = action.payload;
        },
    },
});

export const { changeActiveStepper } = stepperSlice.actions;
export default stepperSlice.reducer;
